// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customCard {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
  margin-bottom: 5px;
}
.sectionHeader {
  padding: 16px 24px !important; /* py={2} = 16px, px={3} = 24px */
  border-bottom: 1px solid #e5e7eb !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  align-items: flex-start !important;
  gap: 16px !important;
}

/* sm and up (min-width: 600px in MUI default theme) */
@media (min-width: 600px) {
  .sectionHeader {
    flex-direction: row !important;
    align-items: center !important;
  }
}

/* Apply this class to the parent container of Snackbar */
.snackbarPosition {
  position: fixed !important;
  top: auto !important;
  bottom: auto !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 1300 !important;
  width: 100% !important;
  max-width: 400px !important;
}

/* Target Snackbar content */
.snackbarPosition.MuiSnackbarContent-root {
  width: 100% !important;
  max-width: 400px !important;
}

/* Responsive: smaller screens */
@media (max-width: 600px) {
  .snackbarPosition {
    width: 90% !important;
    max-width: 90% !important;
    top: 100px !important;
  }

  .snackbarPosition .MuiSnackbarContent-root {
    width: 90% !important;
    max-width: 90% !important;
  }
}

/* Responsive: medium and up */
@media (min-width: 900px) {
  .snackbarPosition {
    top: 100px !important;
  }
}

.textSuccessGreen  {
  color: #25d366;
}

.textGreen  {
  color: #388e3c;
}


.back-button {
  background-color: grey !important;
  color: white !important;
  width: 90%;
}

.back-button:hover {
  background-color: grey !important;
}

.primary-button {
  background-color: #25d366 !important;
  color: white !important;
  width: 90%;
}

.primary-button:hover {
  background-color: "primary.dark" !important;
}
.pac-container {
  z-index: 2000 !important;
}
.header {
  font-size: 18px !important;
  color: #25d366 !important;
}

.customText {
  font-size: 14px !important;
}
.customTextXs {
  font-size: 0.75rem !important;
}

.customTextSm {
  font-size: 0.88rem !important;
}

/* .customSnackbar {
  position: fixed;
  left: 50%;
  top: 100px;
  transform: translateX(-50%);
  width: 100%;
  max-width: 400px;
  z-index: 1400; /* Ensure it appears above other content */

  /* Responsive override for small screens */
  /* @media (max-width: 600px) {
    width: 90%;
    max-width: 90%;
  }
}  */
.customTextField .MuiOutlinedInput-root {
  height: 44px;
  font-size: 14px;
}

.customTextField .MuiInputLabel-root {
  font-size: 14px;
}

.cardNoRides {
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e0e0e0;
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  padding: 2.5rem 1.5rem;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  text-align: center;
}
.noRidesIcon {
  width: 64px;
  height: 64px;
  background-color: #e9ecef;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

@media (min-width: 600px) {
  .trim-on-small {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
  }
}

.whatsapp-book-btn {
  color: white;
  background-color: #25d366; /* Default Bootstrap Primary */
  padding: 10px 20px;
  font-size: 20px;
  text-transform: none;
  border: none;
}
.whatsapp-book-btn:hover {
  background-color: #1ebe57 !important; /* Your custom green */
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/styles/commonStyle.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,+CAA+C;EAC/C,oDAAoD;EACpD,kBAAkB;AACpB;AACA;EACE,6BAA6B,EAAE,iCAAiC;EAChE,2CAA2C;EAC3C,wBAAwB;EACxB,iCAAiC;EACjC,yCAAyC;EACzC,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA,sDAAsD;AACtD;EACE;IACE,8BAA8B;IAC9B,8BAA8B;EAChC;AACF;;AAEA,yDAAyD;AACzD;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,sCAAsC;EACtC,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE;IACE,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;;;2DAO2D;;EAEzD,0CAA0C;EAC1C;;;;IAIE;AACJ;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,sBAAsB;EACtB,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;IAC9B,4BAA4B;IAC5B,+BAA+B;EACjC;AACF;;AAEA;EACE,YAAY;EACZ,yBAAyB,EAAE,8BAA8B;EACzD,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,oCAAoC,EAAE,sBAAsB;EAC5D,YAAY;AACd","sourcesContent":[".customCard {\r\n  border-radius: 12px !important;\r\n  border: 1px solid rgba(0, 0, 0, 0.2) !important;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;\r\n  margin-bottom: 5px;\r\n}\r\n.sectionHeader {\r\n  padding: 16px 24px !important; /* py={2} = 16px, px={3} = 24px */\r\n  border-bottom: 1px solid #e5e7eb !important;\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  justify-content: space-between !important;\r\n  align-items: flex-start !important;\r\n  gap: 16px !important;\r\n}\r\n\r\n/* sm and up (min-width: 600px in MUI default theme) */\r\n@media (min-width: 600px) {\r\n  .sectionHeader {\r\n    flex-direction: row !important;\r\n    align-items: center !important;\r\n  }\r\n}\r\n\r\n/* Apply this class to the parent container of Snackbar */\r\n.snackbarPosition {\r\n  position: fixed !important;\r\n  top: auto !important;\r\n  bottom: auto !important;\r\n  left: 50% !important;\r\n  transform: translateX(-50%) !important;\r\n  z-index: 1300 !important;\r\n  width: 100% !important;\r\n  max-width: 400px !important;\r\n}\r\n\r\n/* Target Snackbar content */\r\n.snackbarPosition.MuiSnackbarContent-root {\r\n  width: 100% !important;\r\n  max-width: 400px !important;\r\n}\r\n\r\n/* Responsive: smaller screens */\r\n@media (max-width: 600px) {\r\n  .snackbarPosition {\r\n    width: 90% !important;\r\n    max-width: 90% !important;\r\n    top: 100px !important;\r\n  }\r\n\r\n  .snackbarPosition .MuiSnackbarContent-root {\r\n    width: 90% !important;\r\n    max-width: 90% !important;\r\n  }\r\n}\r\n\r\n/* Responsive: medium and up */\r\n@media (min-width: 900px) {\r\n  .snackbarPosition {\r\n    top: 100px !important;\r\n  }\r\n}\r\n\r\n.textSuccessGreen  {\r\n  color: #25d366;\r\n}\r\n\r\n.textGreen  {\r\n  color: #388e3c;\r\n}\r\n\r\n\r\n.back-button {\r\n  background-color: grey !important;\r\n  color: white !important;\r\n  width: 90%;\r\n}\r\n\r\n.back-button:hover {\r\n  background-color: grey !important;\r\n}\r\n\r\n.primary-button {\r\n  background-color: #25d366 !important;\r\n  color: white !important;\r\n  width: 90%;\r\n}\r\n\r\n.primary-button:hover {\r\n  background-color: \"primary.dark\" !important;\r\n}\r\n.pac-container {\r\n  z-index: 2000 !important;\r\n}\r\n.header {\r\n  font-size: 18px !important;\r\n  color: #25d366 !important;\r\n}\r\n\r\n.customText {\r\n  font-size: 14px !important;\r\n}\r\n.customTextXs {\r\n  font-size: 0.75rem !important;\r\n}\r\n\r\n.customTextSm {\r\n  font-size: 0.88rem !important;\r\n}\r\n\r\n/* .customSnackbar {\r\n  position: fixed;\r\n  left: 50%;\r\n  top: 100px;\r\n  transform: translateX(-50%);\r\n  width: 100%;\r\n  max-width: 400px;\r\n  z-index: 1400; /* Ensure it appears above other content */\r\n\r\n  /* Responsive override for small screens */\r\n  /* @media (max-width: 600px) {\r\n    width: 90%;\r\n    max-width: 90%;\r\n  }\r\n}  */\r\n.customTextField .MuiOutlinedInput-root {\r\n  height: 44px;\r\n  font-size: 14px;\r\n}\r\n\r\n.customTextField .MuiInputLabel-root {\r\n  font-size: 14px;\r\n}\r\n\r\n.cardNoRides {\r\n  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 1rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);\r\n  padding: 2.5rem 1.5rem;\r\n  font-family: 'Inter', 'Segoe UI', sans-serif;\r\n  text-align: center;\r\n}\r\n.noRidesIcon {\r\n  width: 64px;\r\n  height: 64px;\r\n  background-color: #e9ecef;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 1rem;\r\n}\r\n\r\n@media (min-width: 600px) {\r\n  .trim-on-small {\r\n    white-space: normal !important;\r\n    overflow: visible !important;\r\n    text-overflow: unset !important;\r\n  }\r\n}\r\n\r\n.whatsapp-book-btn {\r\n  color: white;\r\n  background-color: #25d366; /* Default Bootstrap Primary */\r\n  padding: 10px 20px;\r\n  font-size: 20px;\r\n  text-transform: none;\r\n  border: none;\r\n}\r\n.whatsapp-book-btn:hover {\r\n  background-color: #1ebe57 !important; /* Your custom green */\r\n  color: white;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
